/* marabu-currency.js — תצוגת מחיר משוערת במטבע הגולש (02/09/2026).
 *
 * רץ רק בלוקיילים שאינם עברית. לא נוגע במחיר האמיתי: מוסיף לצד כל מחיר ₪
 * תוספת "≈ $1,443" בלבד — החיוב בצ'קאאוט נשאר בשקלים (אין Shopify Payments
 * בישראל, ולכן אין צ'קאאוט רב-מטבעי; זו המוסכמה המקובלת).
 *
 * שערים: open.er-api.com (מתעדכן יומית, נשמר ב-localStorage ל-12 שעות);
 * אם ה-fetch נכשל — שערי fallback אפויים מ-02/09/2026.
 * בחירת מטבע: זיהוי לפי שפת הדפדפן + select ליד בורר השפה, נשמרת מקומית.
 */
(function () {
  'use strict';
  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('he') === 0) return;

  var SYMBOL = { USD: '$', EUR: '€', GBP: '£', CHF: 'CHF ',
                 CAD: 'CA$', AUD: 'A$', JPY: '¥', AED: 'AED ' };
  var FALLBACK = { USD: 0.3302, EUR: 0.2850, GBP: 0.2443, CHF: 0.2681,
                   CAD: 0.4590, AUD: 0.4624, JPY: 52.90, AED: 1.2135 };
  var EURO = ['DE','FR','ES','IT','NL','AT','BE','IE','PT','FI','GR','SK','SI','LV','LT','EE','LU','CY','MT','HR'];
  var R2C = { US: 'USD', GB: 'GBP', CH: 'CHF', CA: 'CAD', AU: 'AUD', JP: 'JPY', AE: 'AED' };
  EURO.forEach(function (r) { R2C[r] = 'EUR'; });

  var rates = FALLBACK;
  var currency;
  try { currency = localStorage.getItem('mrb-currency'); } catch (e) {}
  if (!currency) {
    var region = ((navigator.language || 'en-US').split('-')[1] || '').toUpperCase();
    currency = R2C[region] || 'USD';
  }

  function loadRates() {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem('mrb-rates') || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 12 * 3600e3) { rates = cached.rates; return Promise.resolve(); }
    return fetch('https://open.er-api.com/v6/latest/ILS')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.result === 'success' && d.rates && d.rates.USD) {
          rates = d.rates;
          try { localStorage.setItem('mrb-rates', JSON.stringify({ t: Date.now(), rates: rates })); } catch (e) {}
        }
      })
      .catch(function () { /* נשארים על ה-fallback */ });
  }

  function fmt(ils) {
    var rate = rates[currency] || FALLBACK[currency];
    if (!rate) return null;
    var v = ils * rate;
    var rounded = currency === 'JPY' ? Math.round(v) : (v >= 100 ? Math.round(v) : Math.round(v * 10) / 10);
    return '≈ ' + (SYMBOL[currency] || currency + ' ') + rounded.toLocaleString('en-US');
  }

  var PRICE_RE = /₪\s?(\d[\d,]*(?:\.\d+)?)/g;

  function clearAll() {
    var spans = document.querySelectorAll('.mrb-approx');
    for (var i = 0; i < spans.length; i++) spans[i].parentNode.removeChild(spans[i]);
  }

  function process(root) {
    if (currency === 'ILS') return;
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var targets = [];
    while (w.nextNode()) {
      var node = w.currentNode;
      var p = node.parentElement;
      if (!p) continue;
      var tag = p.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
      if (p.closest('.mrb-approx, .mrb-cc-wrap')) continue;
      PRICE_RE.lastIndex = 0;
      var m = PRICE_RE.exec(node.textContent);
      if (!m) continue;
      if (PRICE_RE.exec(node.textContent)) continue; // שני מחירים בצומת אחד — מדלגים
      // אם כבר הוספנו המרה מיד אחרי הצומת הזה — לא שוב
      if (node.nextSibling && node.nextSibling.classList && node.nextSibling.classList.contains('mrb-approx')) continue;
      targets.push({ node: node, amount: parseFloat(m[1].replace(/,/g, '')) });
    }
    targets.forEach(function (t) {
      var txt = fmt(t.amount);
      if (!txt) return;
      var s = document.createElement('span');
      s.className = 'mrb-approx';
      s.textContent = ' ' + txt;
      s.title = 'Approximate conversion — you will be charged in ILS (₪)';
      t.node.parentNode.insertBefore(s, t.node.nextSibling);
    });
  }

  function addNotes() {
    var anchors = document.querySelectorAll('.totals, .cart__footer .totals__subtotal, .drawer__footer');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i].closest('.cart__footer, .drawer__footer') || anchors[i];
      if (a.querySelector('.mrb-cc-note')) continue;
      var n = document.createElement('p');
      n.className = 'mrb-cc-note';
      n.textContent = 'You will be charged in ILS (₪). Other currencies are approximate.';
      a.appendChild(n);
    }
  }

  function buildSelect() {
    var wrap = document.createElement('span');
    wrap.className = 'mrb-cc-wrap';
    var sel = document.createElement('select');
    sel.className = 'mrb-cc-select';
    sel.setAttribute('aria-label', 'Display currency');
    var opts = ['ILS'].concat(Object.keys(SYMBOL));
    opts.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = c === 'ILS' ? '₪ ILS' : (SYMBOL[c].replace(' ', '') || c) + ' ' + c;
      if (c === currency) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      currency = sel.value;
      try { localStorage.setItem('mrb-currency', currency); } catch (e) {}
      var sels = document.querySelectorAll('.mrb-cc-select');
      for (var i = 0; i < sels.length; i++) sels[i].value = currency;
      clearAll();
      process();
    });
    wrap.appendChild(sel);
    return wrap;
  }

  function placeSelects() {
    var spots = [document.getElementById('HeaderLanguageList'), document.getElementById('FooterLanguageList')];
    var placed = false;
    spots.forEach(function (el) {
      if (!el) return;
      var host = el.closest('noscript') ? null : (el.closest('.localization-form') || el.parentElement);
      if (!host || host.querySelector('.mrb-cc-wrap')) return;
      host.appendChild(buildSelect());
      placed = true;
    });
    if (!placed && !document.querySelector('.mrb-cc-wrap')) {
      var pill = buildSelect();
      pill.classList.add('mrb-cc-fixed');
      document.body.appendChild(pill);
    }
  }

  var css = document.createElement('style');
  css.textContent =
    '.mrb-approx{opacity:.65;font-size:.85em;white-space:nowrap;}' +
    '.mrb-cc-note{margin:.6rem 0 0;font-size:1.1rem;opacity:.65;}' +
    '.mrb-cc-wrap{display:inline-flex;align-items:center;margin-inline-start:1rem;}' +
    '.mrb-cc-select{background:transparent;border:none;font:inherit;color:inherit;cursor:pointer;padding:.2rem;}' +
    '.mrb-cc-select:focus{outline:1px solid currentColor;}' +
    '.mrb-cc-fixed{position:fixed;bottom:1rem;inset-inline-start:1rem;background:#fff;border:1px solid #ddd;border-radius:2rem;padding:.3rem .8rem;z-index:90;}';
  document.head.appendChild(css);

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      process();
      addNotes();
      placeSelects();
    });
  }

  loadRates().then(function () {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
